import React, { useState, useEffect } from "react";

const DisplayLocationBanner = () => {
  const [location, setLocation] = useState("India"); // Default location
  const [loading, setLoading] = useState(true);
  const [backgroundPosition, setBackgroundPosition] = useState("center");

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();

        if (data && data.region) {
          setLocation(data.region); // Set location as state (region)
        } else {
          setLocation("India"); // Fallback
        }
      } catch (error) {
        console.error("Error fetching location:", error);
        setLocation("India"); // Fallback
      } finally {
        setLoading(false);
      }
    };

    fetchLocation();
  }, []);

  // Handle mouse move for dynamic background effect
  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    const xPos = (clientX / windowWidth) * 100;
    const yPos = (clientY / windowHeight) * 100;

    setBackgroundPosition(`${xPos}% ${yPos}%`);
  };

  return (
    <section
      style={{
        background: `radial-gradient(circle at ${backgroundPosition}, #af52ed, #8830df)`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "12px",
        transition: "background 0.1s ease",
      }}
      onMouseMove={handleMouseMove}
    >
      <div >
        <h4
          style={{
            color: "white",
            fontSize: "24px",
            lineHeight: "1.5",
            textAlign: "center",
          }}
        >
          We at{" "}
          <span
            style={{
              backgroundColor: "black",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            Aaban
          </span>{" "}
          are determined to make your business successful in{" "}
          <span
            style={{
              backgroundColor: "black",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {loading ? "Loading..." : location}
          </span>
          .
        </h4>
      </div>

      {/* Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          h4 {
            font-size: 18px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default DisplayLocationBanner;
